<form>
  <!-- Modal Header -->
  <div class="modal-header" style="background-color: cornflowerblue">
    <h4 class="modal-title">Edit Commission</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <!--Amount-->
    <div class="group mt-3">
      <input type="number" required class="textInputLong" name="amount" [(ngModel)]="amount" min="0" (keypress)="sharedService.isNumberKey($event)" />
      <span class="highlight"></span>
      <span class="bar barLong"></span>
      <label>Commission Amount</label>
    </div>

    <!-- Assignee Column -->
    @if (loanCommissionUserList.length > 0) {
      <mat-form-field>
        <mat-label>Assignee</mat-label>
        <select matNativeControl [(ngModel)]="assignee" name="assignee">
          @for (companyUsers of loanCommissionUserList; track companyUsers) {
            <optgroup [label]="companyUsers.companyCode">
              @for (user of companyUsers.usernameList; track user) {
                <option [value]="user">
                  {{ user }}
                </option>
              }
            </optgroup>
          }
        </select>
      </mat-form-field>
    }
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-success" type="button" (click)="confirmBeforeUpdate()">Edit</button>
    <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
  </div>
</form>
